module.exports = __webpack_public_path__ + "assets/img/taiyuan.3552127d.png";